<template>
    <span class="button" :class="mode" v-if="!link" rel="noopener noreferrer">
        <span v-html="text"></span>
    </span>
    <a :href="to" class="button external" :class="mode" target="_blank" v-else-if="external" rel="noopener noreferrer">
        <span v-html="text"></span>
    </a>
    <a :href="to" class="button" :class="mode" v-else-if="action" @click.prevent="action">
        <span v-html="text"></span>
    </a>
    <router-link :to="to" class="button" :class="mode" v-else>
        <span v-html="text"></span>
    </router-link>
</template>

<script>
export default {
    name: 'BetButton',
    props: {
        action: {
            type: Function,
            default: null,
        },
        external: {
            type: Boolean,
            default: false
        },
        link: {
            type: Boolean,
            default: true,
        },
        mode: {
            type: String,
            default: 'normal'
        },
        text: {
            type: String,
            required: true
        },
        to: {
            type: String,
            required: true
        },
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/colors.scss";
@import "@/assets/scss/fonts.scss";

.button {
    // Layout
    display: flex;
    padding: 0.75rem 1.875rem;
    align-items: flex-start;
    width: fit-content;

    // Style
    border: 1px solid $color-betano;
    background: rgba(11, 21, 33, 0.30);
    box-shadow: 0px 0px 8px 0px $color-betano;

    // Typography
    color: $color-betano;
    text-align: center;
    font-family: $ff-cta;
    font-size: 0.8125rem;
    font-style: normal;
    font-weight: 900;
    line-height: 1em;
    /* 0% */
    text-transform: uppercase;
    text-decoration: none;

    // Effects
    transition: 0.2s ease-in-out;
    transition-property: background, box-shadow, color, transform;

    &.white {
        color: $color-white;
        border-color: $color-white;
        background-color: rgba($color-white, 0);
        border-width: 2px;

        &:hover {
            background-color: $color-white;
            color: $color-betano;
        }
    }

    &.black {
        color: $color-black;
        border-color: $color-black;
        background-color: rgba($color-black, 0);
        border-width: 2px;

        &:hover {
            background-color: $color-black;
        }

        &Filled {
            color: $color-white;
            border-color: $color-black;
            background-color: $color-black;
            border-width: 2px;

            &:hover {
                background-color: $color-black;
            }
        }
    }

    &:hover {
        background: $color-betano;
        box-shadow: 0px 0px 0px 0px $color-betano;
        color: white;
    }

    span {
        transform: translateY(.1em);
    }
}
</style>
